import React from 'react';
import { useLocationAndTimeForecast } from '../../Data/Weather';
import Loading from '../Loading';
import WeatherIcon from './WeatherIcon';
import NoValue from '../EmptyStates/NoValue';

export default ({location, date, time}) => {
    const {forecast, isLoading} = useLocationAndTimeForecast(location, date, time);

    const noForecastAvailable = <NoValue text="No forecast available" />;

    if (isLoading) {
        return <Loading size="1x" inline />
    }

    if (!forecast) {
        return noForecastAvailable;
    }

    return <>
        <WeatherIcon title={forecast.weatherTypeTitle} />
        &nbsp; &nbsp;
        {forecast.weatherTypeTitle}
        &nbsp; &nbsp;
        {forecast.temperature}&#8451;
    </>
}
